export type AccountTabScreenId =
  | 'profile'
  | 'credit-and-promo-codes'
  | 'payment-and-gift-cards'
  | 'hsa-fsa'
  | 'gift-cards'
  | 'addresses'
  | 'orders'
  | 'favorites'
  | 'dietary-restrictions'
  | 'notifications';
